export const password_validation = (value) => {
  if (value.length < 6) {
    return false
  }
  /*var format_special_caracters = /[!@#$%^&*()_+\-=[\]{};':"|,.<>/?]/;
  var format_number = /\d/;
  var format_uppercase = /[A-Z]/;

  var contains_special_caracters = format_special_caracters.test(value)
  var contains_number = format_number.test(value);
  var contains_uppercase = format_uppercase.test(value);

  if (contains_special_caracters && contains_number && contains_uppercase) {
    return true
  }
  return false*/
  return true
}

export const documentSizeValidator = (value) =>  {
  if (!value) {
    return true
  }
  if (value == null) {
    return true
  }
  if (value == '') {
    return true
  }
  var file = value
  return (file.size < 5 * 1024 * 1024)
}

export const documentValidator = (value) =>  {
  if (!value) {
    return true
  }
  if (value == null) {
    return true
  }
  if (value == '') {
    return true
  }
  var file = value

  const accepted_extensions = ['jpg', 'png', 'jpeg']
  var re = /(?:\.([^.]+))?$/
  var ext = re.exec(file.name)[1]

  if (ext) {
    return (accepted_extensions.includes(ext.toLowerCase()))
  }
  else {
    return false
  }
}

export const website_validation = (value) => {
  if (!value) return true
  var format = /^(ftp|http|https):\/\/[^ "]+$/
  return format.test(value)
}